module.exports = __webpack_public_path__ + "img/icon-dapp-ethblocks.571d8dde.svg";